<template>
  <el-row style="padding: 50px 50px 0px 50px;" v-loading.body="memberDetailLoading">
    <!-- 会员信息 -->
    <!-- 会员标题 -->
    <el-row class="member-info">
      <el-col>
        <div class="grid-content bg-color" style="padding-left: 30px;">
          <h4>{{generateCustomizeString('memberDetail')}}</h4>
        </div>
      </el-col>
      <!-- 第一部分信息 -->
      <el-col :span="12">
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('username')}}:</span>
          <span class="content-label" v-if="this.memberDetail.phone">{{this.memberDetail.phone}}</span>
          <span class="content-label" v-else-if="this.memberDetail.email">{{this.memberDetail.email}}</span>
          <span class="content-label" v-else-if="this.wechatDetail.nickname">{{this.wechatDetail.nickname}}</span>
          <span class="content-label" v-else-if="this.wechatMiniProgramDetail.nickname">{{this.wechatMiniProgramDetail.nickname}}</span>
          <span class="content-label" v-else>N/A</span>
          <span style="padding-left: 20px;" v-if="this.memberDetail.remark == null">( {{ generateCustomizeString('noComments') }} )</span>
          <span style="padding-left: 20px;" v-else>( {{this.memberDetail.remark}} )</span>
          <el-button @click="editRemark()" style="margin-left:10px;" size="small">{{ generateCustomizeString('editComments')}}</el-button>
        </div>
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('wechatName')}}:</span>
          <span
            class="content-label"
            v-if="this.wechatDetail.nickname"
          >{{this.wechatDetail.nickname}}</span>
          <span
            class="content-label"
            v-else-if="this.wechatMiniProgramDetail.nickname"
          >{{this.wechatMiniProgramDetail.nickname}}</span>
          <span class="content-label" v-else>N/A</span>
        </div>
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('wechatImg')}}:</span>
          <span class="content-label" v-if="this.wechatDetail.headimgurl">
            <img
              :src="this.wechatDetail.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'"
              style="width:auto;height:40px;"
            />
          </span>
          <span class="content-label" v-else-if="this.wechatMiniProgramDetail.headimgurl">
            <img
              :src="this.wechatMiniProgramDetail.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'"
              style="width:auto;height:40px;"
            />
          </span>
          <span class="content-label" v-else>N/A</span>
        </div>
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('memberLevel')}}:</span>
          <span class="content-label" v-if="this.$i18n.locale == 'zh'">{{this.levelName}}</span>
          <span class="content-label" v-if="this.$i18n.locale == 'en'">{{this.levelEnName}}</span>
          <el-button
            @click="editLevel()"
            style="margin-left:20px;"
            size="small"
          >{{generateCustomizeString('edit')}}</el-button>
        </div>
      </el-col>
      <!-- 第二部分信息 -->
      <el-col :span="12">
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('registrationDate')}}:</span>
          <span
            class="content-label"
            v-if="this.memberDetail.created_at"
          >{{this.memberDetail.created_at | toLocalTime}}</span>
        </div>
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('totalAmount')}}:</span>
          <span
            class="content-label"
            v-if="this.memberDetail.points"
          >{{'NZD $' + parseFloat(this.memberDetail.points.total_cost / 100).toFixed(2)}}</span>
          <span class="content-label" v-else>NZD $0.00</span>
        </div>
        <div class="grid-content bg-color">
          <span class="title-label">{{generateCustomizeString('memberCredit')}}:</span>
          <span
            class="content-label"
            v-if="this.memberDetail.credits"
          >{{'NZD $' + parseFloat(this.memberDetail.credits.credits / 100).toFixed(2)}}</span>
          <span class="content-label" v-else>NZD $0.00</span>
          <el-button
            @click="editCreditDialog()"
            style="margin-left:20px;"
            size="small"
          >{{generateCustomizeString('edit')}}</el-button>
        </div>
      </el-col>
    </el-row>

    <!-- 订单信息 -->
    <el-row>
      <el-col style="padding: 10px 0 0 0;">
        <div class="grid-content">
          <h4>{{generateCustomizeString('memberOrder')}}</h4>
        </div>
      </el-col>
      <el-form
        :inline="true"
        ref="searchForm"
        :model="searchForm"
        class="search-form-inline"
        size="mini"
      >
        <el-form-item :label="generateCustomizeString('orderTimeRange')">
          <el-date-picker
            v-model="searchForm.datetimeRange"
            type="datetimerange"
            :picker-options="datetimeRangePickerOptions"
            range-separator="-"
            :start-placeholder="generateCustomizeString('start')"
            :end-placeholder="generateCustomizeString('end')"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            style="width: 460px;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="float: right; right: 30px;">
          <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
          <el-button @click="goToAllOrderList()">{{generateCustomizeString('batchExportOrders')}}</el-button>
          <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="6">
        <span style="margin-right: 10px;">{{ generateCustomizeString('PeriodtotalOrders') }}:</span>
        <el-tag type="info">{{ periodtotalStat.all_order_count }}</el-tag>
      </el-col>
      <el-col :span="6">
        <span style="margin-right: 10px;">{{ generateCustomizeString('PeriodtotalSpend') }}:</span>
        <el-tag type="info">{{ periodtotalStat.all_sales_amount | formatPrice }}</el-tag>
      </el-col>
      <el-col :span="6">
        <span style="margin-right: 10px;">{{ generateCustomizeString('successOrders') }}:</span>
        <el-tag type="success">{{ periodtotalStat.order_count }}</el-tag>
      </el-col>
      <el-col :span="6">
        <span style="margin-right: 10px;">{{ generateCustomizeString('successSpend') }}:</span>
        <el-tag type="warning">{{ periodtotalStat.sales_amount | formatPrice }}</el-tag>
      </el-col>
    </el-row>

    <el-col style="padding-bottom: 100px;">
      <el-table
        :data="memberOrders"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="memberOrdersFetchLoding"
      >
        <el-table-column prop="orderId" :label="generateCustomizeString('orderId')"></el-table-column>
        <el-table-column prop="totalAmount" :label="generateCustomizeString('totalAmount')"></el-table-column>
        <!-- <el-table-column prop="paymentMethod" :label="generateCustomizeString('paymentMethod')">
        </el-table-column>-->
        <el-table-column prop="orderStatus" :label="generateCustomizeString('orderStatus')"></el-table-column>
        <el-table-column :label="generateCustomizeString('orderCreateAt')">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.orderCreateAt | toLocalTime }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <el-button
              @click="viewClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('view')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col style="margin-top: 10px; padding: 5px; background-color: #eee;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="15"
          layout="total, prev, pager, next"
          :total="currentTotal"
        ></el-pagination>
      </el-col>
    </el-col>

    <el-dialog :title="generateCustomizeString('editUserRemarks')" :visible.sync="editRemarkDialogVisible" width="40%">
      <el-form :model="remarkForm" ref="remarkForm" label-width="150px">
        <el-form-item :label="generateCustomizeString('userRemarks')" prop="remark">
          <el-input v-model="remarkForm.remark" style="width: 70%;"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button
          @click="editRemarkDialogVisible = false"
          style="margin-right: 30px"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button type="primary" @click="updateRemarkClick">{{ generateCustomizeString('edit') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="generateCustomizeString('editLevel')"
      :visible.sync="editLevelDialogVisible"
      width="40%"
    >
      <el-form :model="levelForm" :rules="levelRules" ref="levelForm" label-width="150px">
        <el-form-item :label="generateCustomizeString('selectLevel')" prop="level">
          <el-select
            v-model="levelForm.level"
            :placeholder="generateCustomizeString('selectLevel')"
            style="width: 70%;"
          >
          <template v-if="$i18n.locale == 'zh'">
            <el-option
              v-for="(level, index) in levels"
              :key="index"
              :value="level.level"
              :label="level.name"
            ></el-option>
          </template>
          <template v-else-if="$i18n.locale == 'en'">
            <el-option
              v-for="(level, index) in levels"
              :key="index"
              :value="level.level"
              :label="level.enName"
            ></el-option>
          </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button
          @click="editLevelDialogVisible = false"
          style="margin-right: 30px"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button type="primary" @click="onUpdateLevel">{{generateCustomizeString('update')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('editCredit')"
      :visible.sync="dialogCreditFormVisible"
      width="80%"
      v-loading="editCreditLoading"
    >
      <el-form :model="creditForm" :rules="rules" ref="creditForm" label-width="150px">
        <el-form-item :label="generateCustomizeString('memberCreditEdit')" prop="credits">
          <el-input
            v-model="creditForm.credits"
            style="width: 400px;"
            @keyup.enter.native="updateCreditClick"
            disabled
          >
            <template slot="prepend">NZD $</template>
          </el-input>
          <el-button
            @click="editCreditCardVisible = !editCreditCardVisible"
            style="margin-left: 10px"
          >{{generateCustomizeString('editCreditButton')}}</el-button>
        </el-form-item>
      </el-form>
      <div v-if="editCreditCardVisible === true" style="width: 85%; margin: 30px auto;">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="generateCustomizeString('addCredit')"
            name="add"
            style="padding: 20px 0;"
          >
            <el-form :model="addCreditForm" :rules="rules" ref="addCreditForm" label-width="100px">
              <el-form-item :label="generateCustomizeString('addCredit')" prop="credits">
                <el-input
                  v-model="addCreditForm.delta_credits"
                  type="number"
                  step="0.01"
                  style="width: 400px;"
                >
                  <template slot="prepend">NZD $</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('comment')">
                <el-input v-model="addCreditForm.comment" style="width: 400px;"></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer">
              <el-button
                @click="editCreditCardVisible = false"
                style="margin-right: 30px"
              >{{generateCustomizeString('cancel')}}</el-button>
              <el-button
                type="primary"
                @click="addCreditClick"
              >{{generateCustomizeString('update')}}</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="generateCustomizeString('reduceCredit')"
            name="reduce"
            style="padding: 20px 0;"
          >
            <el-form
              :model="reduceCreditForm"
              :rules="rules"
              ref="reduceCreditForm"
              label-width="100px"
            >
              <el-form-item :label="generateCustomizeString('reduceCredit')" prop="credits">
                <el-input
                  v-model="reduceCreditForm.delta_credits"
                  type="number"
                  step="0.01"
                  style="width: 400px;"
                >
                  <template slot="prepend">NZD $</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('comment')">
                <el-input v-model="reduceCreditForm.comment" style="width: 400px;"></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer">
              <el-button
                @click="editCreditCardVisible = false"
                style="margin-right: 30px"
              >{{generateCustomizeString('cancel')}}</el-button>
              <el-button
                type="primary"
                @click="reduceCreditClick"
              >{{generateCustomizeString('update')}}</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="padding-top: 30px;">
        <div class="grid-content bg-purple" style="background-color: #f2f2f2; padding-left: 30px;">
          <h4>{{generateCustomizeString('creditOperationLog')}}</h4>
        </div>
        <el-table
          :data="creditOperationLog"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading.body="creditOperationLogLoading"
        >
          <el-table-column prop="operator" :label="generateCustomizeString('operator')"></el-table-column>
          <el-table-column prop="operatingTime" :label="generateCustomizeString('operatingTime')"></el-table-column>
          <el-table-column prop="creditAmount" :label="generateCustomizeString('creditAmount')"></el-table-column>
          <el-table-column
            prop="operationDetails"
            :label="generateCustomizeString('operationType')"
          ></el-table-column>
          <el-table-column prop="message" :label="generateCustomizeString('operationDetails')"></el-table-column>
          <el-table-column prop="comment" :label="generateCustomizeString('comment')"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'

const defaultCreditOperation = {
  credits: 0
}
const defaultRemarkOperation = {
  remark: ''
}

const originOrderSearchFrom = {
  datetimeRange: []
}

export default {
  name: 'MemberDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isOrderStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      datetimeRangePickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('lastWeek'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'week')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastMonth'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastThreeMonths'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(3, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          }
        ]
      },
      currentPage: 1,
      currentTotal: 0,
      memberDetail: [],
      memberOrders: [],
      wechatDetail: [],
      wechatMiniProgramDetail: [],
      levelName: '',
      levelEnName: '',
      creditOperationLog: [],
      creditForm: Object.assign({}, defaultCreditOperation),
      dialogCreditFormVisible: false,
      creditOperationLogLoading: false,
      editLevelDialogVisible: false,
      editLevelLoading: false,
      memberDetailLoading: false,
      editCreditLoading: false,
      editRemarkDialogVisible: false,
      memberOrdersFetchLoding: false,
      levels: [],
      levelForm: {
        level: null
      },
      remarkForm: Object.assign({}, defaultRemarkOperation),
      rules: {},
      levelRules: {
        level: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      },
      editCreditCardVisible: false,
      activeName: 'add',
      addCreditForm: {
        delta_credits: '',
        comment: ''
      },
      reduceCreditForm: {
        delta_credits: '',
        comment: ''
      },
      searchForm: Object.assign({}, originOrderSearchFrom),
      filters: {},
      periodtotalStat: {
        order_count: 0,
        sales_amount: 0,
        all_order_count: 0,
        all_sales_amount: 0
      }
    }
  },
  methods: {
    generateCustomizeString,
    viewClick(row) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: row.transactionId }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    editLevel() {
      if (this.levels.length === 0) {
        this.fetchAllLevels()
      }
      this.editLevelDialogVisible = true
    },
    onUpdateLevel() {
      // 接口更新等级
      this.$refs.levelForm.validate(vaild => {
        if (vaild) {
          const level = this.levelForm.level
          this.fetchUpdateLevel(this.memberDetail.id, level)
        }
      })
    },
    editRemark() {
      this.editRemarkDialogVisible = !this.editRemarkDialogVisible
      this.remarkForm.remark = this.memberDetail.remark
    },
    updateRemarkClick() {
      var data = {
        remark: this.remarkForm.remark
      }
      request({
        url: 'customer/' + this.$route.params.memberId + '/remark',
        method: 'patch',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: this.generateCustomizeString('settingSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('settingFailed'))
          }
          this.fetchMemberInfo()
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('settingFailed'))
        })
        .finally(() => {
          this.editRemarkDialogVisible = false
        })
    },
    editCreditDialog() {
      this.dialogCreditFormVisible = true
      this.editCredit()
    },
    editCredit() {
      this.editCreditLoading = true
      request({
        url: 'credits/' + this.memberDetail.credits.id,
        method: 'get'
      })
        .then(response => {
          for (const i in this.creditForm) {
            this.creditForm[i] = response.data[i]
            this.creditForm.credits = parseFloat(
              (response.data.credits * 100) / 10000
            ).toFixed(2)
          }
          var logData = []
          for (let i = 0; i < response.data.credits_records.length; i++) {
            var obj = {}
            obj.operator = response.data.credits_records[i].operator
            obj.operatingTime = dayjs(new Date(response.data.credits_records[i].created_at)).format('YYYY-MM-DD HH:mm:ss')
            obj.creditAmount =
              'NZD $' +
              ((response.data.credits_records[i].quantity / 100) * 1000) / 1000
            obj.operationDetails = response.data.credits_records[i].status_name
            obj.message = response.data.credits_records[i].message
            obj.comment = response.data.credits_records[i].comment
            logData[i] = obj
          }
          this.creditOperationLog = logData
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.editCreditLoading = false
        })
    },
    handleCurrentChange(val) {
      this.fetchMemberOrder(val)
    },
    addCreditClick() {
      console.log(this.addCreditForm.credits)
      var data = {
        delta_credits: '+' + Math.round(parseInt(this.addCreditForm.delta_credits * 1000000) / 10000),
        comment: this.addCreditForm.comment
      }
      request({
        url: 'customer/credits/' + this.memberDetail.credits.id,
        method: 'post',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: this.generateCustomizeString('settingSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('settingFailed'))
          }
          this.editCredit()
          this.fetchMemberInfo()
          this.addCreditForm.delta_credits = ''
          this.addCreditForm.comment = ''
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('settingFailed'))
        })
    },
    reduceCreditClick() {
      var data = {
        delta_credits: '-' + Math.round(parseInt(this.reduceCreditForm.delta_credits * 1000) / 10),
        comment: this.reduceCreditForm.comment
      }
      request({
        url: 'customer/credits/' + this.memberDetail.credits.id,
        method: 'post',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: this.generateCustomizeString('settingSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('settingFailed'))
          }
          this.editCredit()
          this.fetchMemberInfo()
          this.reduceCreditForm.delta_credits = ''
          this.reduceCreditForm.comment = ''
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('settingFailed'))
        })
    },
    fetchUpdateLevel(customerId, level) {
      if (this.editLevelLoading) return
      this.editLevelLoading = true
      request({
        url: `customer/${customerId}/level`,
        method: 'patch',
        data: {
          level
        }
      })
        .then(response => {
          this.$refs.levelForm.resetFields()
          this.editLevelDialogVisible = false
          this.fetchMemberInfo()
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.editLevelLoading = false
        })
    },
    fetchMemberInfo() {
      return new Promise((resolve, reject) => {
        request({
          url: 'customer/' + this.$route.params.memberId,
          method: 'get'
        })
          .then(response => {
            const memberData = response.data
            // const wechatData = response.data.wechat_auths[0].user_info
            this.memberDetail = memberData
            if (this.memberDetail.created_at) {
              this.memberDetail.created_at = this.memberDetail.created_at.replace(
                /-/g,
                '/'
              )
            }
            if (
              response.data.wechat_auths.length &&
              response.data.wechat_auths[0].user_info
            ) {
              this.wechatDetail = response.data.wechat_auths[0].user_info
            }
            if (
              response.data.wechat_mini_auths.length &&
              response.data.wechat_mini_auths[0].userinfo
            ) {
              this.wechatMiniProgramDetail = response.data.wechat_mini_auths[0].userinfo
            }
            if (this.memberDetail.points) {
              if (this.memberDetail.points.level_info) {
                this.levelName = this.memberDetail.points.level_info.name
                switch (this.levelName) {
                  case '青铜':
                    this.levelEnName = this.generateCustomizeString('青铜')
                    break
                  case '白银':
                    this.levelEnName = this.generateCustomizeString('白银')
                    break
                  case '黄金':
                    this.levelEnName = this.generateCustomizeString('黄金')
                    break
                  case '铂金':
                    this.levelEnName = this.generateCustomizeString('铂金')
                    break
                  case '钻石':
                    this.levelEnName = this.generateCustomizeString('钻石')
                    break
                  case '星耀':
                    this.levelEnName = this.generateCustomizeString('星耀')
                    break
                  case '王者':
                    this.levelEnName = this.generateCustomizeString('王者')
                    break
                  default:
                    this.levelEnName = this.levelName
                }
              } else if (this.memberDetail.points.level === 0) {
                this.levelName = '无'
                this.levelEnName = 'N.A'
              } else {
                this.levelName = '无'
                this.levelEnName = 'N.A'
              }
            } else {
              this.levelName = '无'
              this.levelEnName = 'N.A'
            }
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
          .finally(() => {
            this.memberDetailLoading = false
          })
      })
    },
    fetchAllLevels() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/level/list',
          method: 'get'
        })
          .then(response => {
            this.levels = response.data
            for (var i = 0; i < this.levels.length; i++) {
              switch (this.levels[i].name) {
                case '青铜':
                  this.levels[i].enName = this.generateCustomizeString('青铜')
                  break
                case '白银':
                  this.levels[i].enName = this.generateCustomizeString('白银')
                  break
                case '黄金':
                  this.levels[i].enName = this.generateCustomizeString('黄金')
                  break
                case '铂金':
                  this.levels[i].enName = this.generateCustomizeString('铂金')
                  break
                case '钻石':
                  this.levels[i].enName = this.generateCustomizeString('钻石')
                  break
                case '星耀':
                  this.levels[i].enName = this.generateCustomizeString('星耀')
                  break
                case '王者':
                  this.levels[i].enName = this.generateCustomizeString('王者')
                  break
                default:
                  this.levels[i].enName = this.levels[i].name
              }
            }
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
          .finally(() => {})
      })
    },
    fetchMemberOrder(page) {
      if (this.memberOrdersFetchLoding) return
      this.memberOrdersFetchLoding = true
      const params = {
        customer_id: this.$route.params.memberId,
        ...this.filters,
        page: page,
        page_size: 15
      }
      request({
        // url: 'customer/' + this.$route.params.memberId + '/order-list',
        url: '/order-list',
        method: 'get',
        params: params
      })
        .then(response => {
          const meta = response.meta
          const data = []
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.orderId = response.data[i].out_trade_no
            obj.creditId = response.data[i].credit_id
            obj.transactionId = response.data[i].id
            obj.totalAmount =
              'NZD $' + parseFloat(response.data[i].fee / 100).toFixed(2)
            obj.paymentMethod = response.data[i].payment_method
            obj.orderStatus = this.getOrderStatus(response.data[i].status)
            obj.orderCreateAt = response.data[i].created_at.replace(/-/g, '/')
            data[i] = obj
          }
          this.memberOrders = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
          this.fetchMemberPeriodSum()
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.memberOrdersFetchLoding = false
        })
    },
    fetchMemberPeriodSum() {
      request({
        url: '/customer/' + this.$route.params.memberId + '/order/stat',
        method: 'get',
        params: {
          ...this.filters
        }
      }).then(response => {
        if (response.status === 0) {
          this.periodtotalStat = response.data
        }
      })
    },
    // 订单状态:0未付款 10已付款（待发货）20已发货（待完成）30未付款已发货 40交易完成 50申请退款 60退款完成 99已关闭
    getOrderStatus(orderStatus) {
      var status = ''
      switch (orderStatus) {
        case 0:
          status = this.generateCustomizeString('未付款')
          break
        case 10:
          status = this.generateCustomizeString('已付款（待发货）')
          break
        case 15:
          status = this.generateCustomizeString('配货中')
          break
        case 20:
          status = this.generateCustomizeString('已发货（待完成）')
          break
        case 30:
          status = this.generateCustomizeString('未付款已发货（待完成）')
          break
        case 40:
          status = this.generateCustomizeString('交易完成')
          break
        case 50:
          status = this.generateCustomizeString('申请退款')
          break
        case 60:
          status = this.generateCustomizeString('退款完成')
          break
        case 99:
          status = this.generateCustomizeString('已关闭')
          break
      }
      return status
    },
    goToAllOrderList() {
      let username = ''
      if (this.wechatDetail.nickname) {
        username = this.wechatDetail.nickname
      } else {
        username = this.memberDetail.phone
      }
      const params = {
        customerId: this.$route.params.memberId,
        datetimeRange: this.searchForm.datetimeRange,
        displayName: username
      }

      this.$router.push({
        name: 'All',
        params: params
      })
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (
            this.searchForm.datetimeRange &&
            this.searchForm.datetimeRange.length === 2
          ) {
            const dates = this.searchForm.datetimeRange.map(date =>
              dayjs(date)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
            )
            params.start_created_at = dates[0]
            params.end_created_at = dates[1]
            delete params.datetimeRange
          }
          console.log(params)
          this.filters = params
          this.fetchMemberOrder(1)
          // this.fetchPeriodSpend
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originOrderSearchFrom)
      this.filters = {}
      this.fetchMemberOrder(1)
    },
    getLocalTime(date, i) {
      // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return
      var d = new Date(date)
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime - 3600000 * i)
    }
  },
  created: function() {
    this.memberDetailLoading = true
    Promise.all([this.fetchAllLevels()])
      .then(result => {
        this.fetchMemberInfo()
      })
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.memberDetailLoading = false
      })
    // this.fetchMemberInfo()
    this.fetchMemberOrder(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-userForm {
  padding: 50px 50px 0px 0px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-color {
  //background: #F2F6FC;
}
.bg-purple-light {
  background: #e5e9f2;
}
.member-info {
  padding: 30px 0;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
.grid-content {
  min-height: 60px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.title-label {
  display: inline-block;
  text-align: right;
  width: 160px;
}
.content-label {
  padding: 0px 0px 0px 20px;
}
.dialog-footer {
  padding-left: 150px;
  padding-top: 10px;
}
.el-select-dropdown {
  z-index: 1000001 !important;
}
</style>
